const House = [
  {
    category: "house",
    subcategory: "Flowers",
    name: "150pcs / pack de graines de fleurs Hosta",
    price: "4.99",
    raw_price: "8.99",
    currency: "USD",
    discount: "45",
    likes_count: "867",
    is_new: "false",
    brand: "Egrow",
    brand_url: "https://fr.newchic.com/egrow-brand-819.html",
    codCountry: "PH,TH,VN",
    variation_0_color: "Violet",
    variation_1_color: "vert",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/banggood/images/8E/58/668fcfb1-f341-4316-b871-bfd143d070fa.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/banggood/images/8E/58/668fcfb1-f341-4316-b871-bfd143d070fa.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/banggood/images/5A/E8/242bfcc1-f15e-479b-9003-fc72a469eccc.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/banggood/images/5A/E8/242bfcc1-f15e-479b-9003-fc72a469eccc.jpg",
    image_url: "",
    url: "https://fr.newchic.com/egrow-flowers-8679/p-1317953.html",
    id: "1317953",
    model: "SKU967403",
  },
  {
    category: "house",
    subcategory: "Home Carpets",
    name: "Tapis de maison antidérapants de style floral classique européen",
    price: "16.17",
    raw_price: "43.74",
    currency: "USD",
    discount: "63",
    likes_count: "703",
    is_new: "false",
    brand: "DecBest",
    brand_url: "https://fr.newchic.com/decbest-brand-1365.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#1",
    variation_1_color: "#2",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/35/A1/909198d8-e3c8-40a1-a20c-0d64a6eb627e.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/35/A1/909198d8-e3c8-40a1-a20c-0d64a6eb627e.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D9/E1/4a782fc4-b1bf-47a4-bdbf-6df7122d16b7.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D9/E1/4a782fc4-b1bf-47a4-bdbf-6df7122d16b7.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B0/F3/3cc4e9da-e0fc-4e14-bca4-03bf0c4082e5.jpg",
    url: "https://fr.newchic.com/decbest-home-carpets-7216/p-1496436.html",
    id: "1496436",
    model: "SKUC30634",
  },
  {
    category: "house",
    subcategory: "Outdoor Tools",
    name: "IPRee ™ 30KN Rappel d'escalade Dscender Eight Ring",
    price: "14.99",
    raw_price: "25.99",
    currency: "USD",
    discount: "42",
    likes_count: "52",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/68/54/71047677-fea2-4339-b98d-fdd6ef7496fd.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/outdoor-tools-7288/p-907293.html",
    id: "907293",
    model: "SKU093263",
  },
  {
    category: "house",
    subcategory: "Outdoor Tools",
    name:
      "Bâton d'auto-défense à poteau télescopique à 3 sections Outil d'évacuation d'urgence pour bâton rétractable",
    price: "13.99",
    raw_price: "34.97",
    currency: "USD",
    discount: "60",
    likes_count: "120",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B7/A8/e579680c-f35c-4085-a441-297f54c5d5db.jpeg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/outdoor-tools-7288/p-1339082.html",
    id: "1339082",
    model: "SKUA06367",
  },
  {
    category: "house",
    subcategory: "Fournitures de nettoyage",
    name: "Couvre-pied jetable automatique pour machine à film pour chaussures",
    price: "74.99",
    raw_price: "151.24",
    currency: "USD",
    discount: "50",
    likes_count: "222",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#1",
    variation_1_color: "#2",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6E/FF/00ae178f-2dd0-4a80-9be8-8d3e02605a93.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6E/FF/00ae178f-2dd0-4a80-9be8-8d3e02605a93.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A9/56/c397f7cb-c035-42df-8760-b94cf7629a9f.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A9/56/c397f7cb-c035-42df-8760-b94cf7629a9f.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BF/8A/c20dfb9b-e772-4219-b51a-87459221089a.jpg",
    url: "https://fr.newchic.com/cleaning-supplies-4918/p-1664674.html",
    id: "1664674",
    model: "SKUF00488",
  },
  {
    category: "house",
    subcategory: "Literie",
    name: "Housse de couette en fibre de polyester de luxe Soft",
    price: "41.29",
    raw_price: "89.5",
    currency: "USD",
    discount: "54",
    likes_count: "467",
    is_new: "false",
    brand: "SOFO",
    brand_url: "",
    codCountry: "",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BF/23/7fd7a743-15f2-4e7a-a79a-be6fdb5d0f5f.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/bedding-sets-5811/p-1332456.html",
    id: "1332456",
    model: "SKUA10391",
  },
  {
    category: "house",
    subcategory: "Flowers",
    name: "Lot de 100 pcs semences de lithops bleus vivaces pseudotruncatella",
    price: "5.99",
    raw_price: "10.99",
    currency: "USD",
    discount: "46",
    likes_count: "2082",
    is_new: "false",
    brand: "Egrow",
    brand_url: "https://fr.newchic.com/egrow-brand-819.html",
    codCountry: "PH,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/banggood/images/FB/03/f586135d-f5e4-4e8a-b6b2-80af86323783.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/egrow-flowers-8679/p-1244169.html",
    id: "1244169",
    model: "SKU820961",
  },
  {
    category: "house",
    subcategory: "Grasses",
    name: "Herbe de la pampa arc-en-ciel",
    price: "6.71",
    raw_price: "10.99",
    currency: "USD",
    discount: "39",
    likes_count: "1535",
    is_new: "false",
    brand: "Egrow",
    brand_url: "https://fr.newchic.com/egrow-brand-819.html",
    codCountry: "",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/37/D0/ac6b7ad2-215e-41f7-aea3-d2c66bd85ecf.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/egrow-grasses-8677/p-1432170.html",
    id: "1432170",
    model: "SKUB42528",
  },
  {
    category: "house",
    subcategory: "Fournitures de nettoyage",
    name: "Machine de film de chaussure maison automatique nouveau jetable ",
    price: "79.51",
    raw_price: "150.75",
    currency: "USD",
    discount: "47",
    likes_count: "136",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DB/08/dd2cbff4-b875-4bfb-8a2e-a915bfeafba0.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/cleaning-supplies-4918/p-1657579.html",
    id: "1657579",
    model: "SKUE87086",
  },
  {
    category: "house",
    subcategory: "Dessert Decorators",
    name:
      "Ensemble de 52 pièces Platine à gâteau 32 pièces Ensemble de conseils de tuyauterie",
    price: "24.01",
    raw_price: "49",
    currency: "USD",
    discount: "51",
    likes_count: "114",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6B/FD/cf927c1a-00b0-4667-a15b-e813a0a14068.jpeg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/dessert-decorators-7266/p-1632823.html",
    id: "1632823",
    model: "SKUB62466",
  },
  {
    category: "house",
    subcategory: "Desktop Holder",
    name:
      "Ring Fill Light Lamp NO / WITH Trépied for Selfie Photography Vlog Live Streaming Camera Video Beauty",
    price: "4.99",
    raw_price: "12.5",
    currency: "USD",
    discount: "60",
    likes_count: "156",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#3",
    variation_1_color: "#2",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E6/0A/6019fcca-5e06-425b-a3b9-697eb9b46227.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E6/0A/6019fcca-5e06-425b-a3b9-697eb9b46227.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/9F/08/98551d2d-da5e-42f6-a180-35902f415ec8.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9F/08/98551d2d-da5e-42f6-a180-35902f415ec8.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/3C/B9/36852e70-7bd1-403c-a7fe-ac33713199a0.jpeg",
    url: "https://fr.newchic.com/desktop-holder-6153/p-1579954.html",
    id: "1579954",
    model: "SKUC55584",
  },
  {
    category: "house",
    subcategory: "Outdoor Tools",
    name:
      "3000RPM / min Kit de scie sabre électrique sans fil pour scie alternative sans fil pour Makita 18V Batterie 100 mm / 2 mm (Batterie non inclus)",
    price: "43.99",
    raw_price: "109.99",
    currency: "USD",
    discount: "60",
    likes_count: "44",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/60/2B/b1ab10fc-6e2d-4344-88df-327c4258ecc0.jpeg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/outdoor-tools-7288/p-1687358.html",
    id: "1687358",
    model: "SKUE54645",
  },
  {
    category: "house",
    subcategory: "Food Storage",
    name:
      "Ensemble de réservoir d'assaisonnement rotatif de cuisine Rangement de cuisine",
    price: "9.99",
    raw_price: "16.99",
    currency: "USD",
    discount: "41",
    likes_count: "165",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/04/E0/33f0e06a-0349-48c4-b915-c9be6b87e0d2.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/04/E0/33f0e06a-0349-48c4-b915-c9be6b87e0d2.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/68/54/71047677-fea2-4339-b98d-fdd6ef7496fd.jpg",
    url:
      "https://fr.newchic.com/bottles-and-jars-and-boxes-7256/p-1663485.html",
    id: "1663485",
    model: "SKUE92687",
  },
  {
    category: "house",
    subcategory: "Flowers",
    name:
      "400pcs Egrow 4 Varieties Mixed Rose Flowers Seeds Pink Succulen Blue Witchford Seeds",
    price: "12.99",
    raw_price: "25.99",
    currency: "USD",
    discount: "50",
    likes_count: "118",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "PH,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CF/07/1670f7a6-924d-41f0-93c8-a84fe0d30da4.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/flowers-8679/p-1677994.html",
    id: "1677994",
    model: "SKU578184+SKU903970",
  },
  {
    category: "house",
    subcategory: "Artisanat",
    name:
      "83 pièces / ensemble moule en silicone pour résine silicone uv résine bricolage argile résine époxy moulage moules et outils fixés avec sac de rangement pour bijoux",
    price: "14.99",
    raw_price: "37.48",
    currency: "USD",
    discount: "60",
    likes_count: "101",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/60/E3/ba978948-0948-4d67-933a-bd83609e28ec.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/crafting-5493/p-1684835.html",
    id: "1684835",
    model: "SKUE83582",
  },
  {
    category: "house",
    subcategory: "Home Carpets",
    name: "Tapis antidérapants SeaShell",
    price: "12.44",
    raw_price: "27.78",
    currency: "USD",
    discount: "55",
    likes_count: "76",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#1",
    variation_1_color: "#2",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/70/16/0c938dfe-d985-4218-8be7-b5b75cc5e308.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/70/16/0c938dfe-d985-4218-8be7-b5b75cc5e308.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/DE/BF/8646bba4-5d27-45d3-a2d3-4f25f3cbc5e6.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/DE/BF/8646bba4-5d27-45d3-a2d3-4f25f3cbc5e6.jpeg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/27/3D/ba57ce26-611d-49da-93cd-346d78f60edb.jpeg",
    url: "https://fr.newchic.com/home-carpets-7216/p-1549991.html",
    id: "1549991",
    model: "SKUC93100",
  },
  {
    category: "house",
    subcategory: "Other Tools",
    name: "Porte d'armoire de cuisine pliante murale 13L",
    price: "15.99",
    raw_price: "30.99",
    currency: "USD",
    discount: "48",
    likes_count: "95",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Gray",
    variation_1_color: "Green",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/56/F5/16ad7a21-1ab7-4a6f-a607-7139978b899a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/56/F5/16ad7a21-1ab7-4a6f-a607-7139978b899a.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C0/72/48d072f9-58b3-4950-bb0d-331a36b55865.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C0/72/48d072f9-58b3-4950-bb0d-331a36b55865.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/ED/41/2cb0a6fd-9324-402d-bb7c-3b71e93cd01b.jpg",
    url: "https://fr.newchic.com/other-kitchen-tools-5983/p-1700474.html",
    id: "1700474",
    model: "SKUF49353",
  },
  {
    category: "house",
    subcategory: "Pesticides",
    name:
      "Anti-Mosquito Lamp Electric Fly Bug Zapper Mosquito Insect Killer Lamp LED Light Trap Lamp Pest Control",
    price: "15.99",
    raw_price: "46.68",
    currency: "USD",
    discount: "66",
    likes_count: "453",
    is_new: "false",
    brand: "Loskii",
    brand_url: "https://fr.newchic.com/loskii-brand-347.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/CF/A9/efcda870-ee66-4169-a681-00c0308c59b6.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CF/A9/efcda870-ee66-4169-a681-00c0308c59b6.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/FF/71/c8b9c6e3-03cc-4131-b43d-36c8b219ef7f.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FF/71/c8b9c6e3-03cc-4131-b43d-36c8b219ef7f.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5C/75/4c472e47-0318-46d0-a4d5-308ceec433c6.jpg",
    url:
      "https://fr.newchic.com/loskii-pests-control-and-killer-4919/p-1440132.html",
    id: "1440132",
    model: "SKUB44572",
  },
  {
    category: "house",
    subcategory: "Other Tools",
    name:
      "Accessoires de cuisine gomme éponge avec poignée éponge de nettoyage brosses cuisine salle de bain brosse de décontamination forte",
    price: "5.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "124",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C2/77/96810f17-25e6-4c96-92da-f6cb77e17154.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/other-kitchen-tools-5983/p-1655134.html",
    id: "1655134",
    model: "SKUE83543",
  },
  {
    category: "house",
    subcategory: "Tapisseries",
    name:
      "Tenture murale Mystics tapisserie psychédélique motif champignon Mandala tapis",
    price: "15.11",
    raw_price: "33.08",
    currency: "USD",
    discount: "54",
    likes_count: "327",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/28/58/f6c57d2b-c086-4c35-b771-b07a26f7f7fd.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/tapestries-5492/p-1572776.html",
    id: "1572776",
    model: "SKUD33444",
  },
  {
    category: "house",
    subcategory: "Boîte de stockage",
    name: "Boîte de papier hygiénique de salon",
    price: "9.99",
    raw_price: "15.99",
    currency: "USD",
    discount: "38",
    likes_count: "70",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "Dark Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/CB/CE/22f08980-54c1-48b8-9779-c645ab9535b6.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CB/CE/22f08980-54c1-48b8-9779-c645ab9535b6.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/95/C8/014f78a3-d159-4022-b018-b263eea1ac12.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/95/C8/014f78a3-d159-4022-b018-b263eea1ac12.jpg",
    url: "https://fr.newchic.com/storage-boxes-4913/p-1698000.html",
    id: "1698000",
    model: "SKUF52328",
  },
  {
    category: "house",
    subcategory: "Other Tools",
    name:
      "12 pièces noir insonorisation mousse panneau mural acoustique isolation phonique mousse studio carreaux de mur",
    price: "14.99",
    raw_price: "37.5",
    currency: "USD",
    discount: "60",
    likes_count: "200",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E3/76/de597412-0ca9-4f21-8293-a2c9299c7eea.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/other-kitchen-tools-5983/p-1130524.html",
    id: "1130524",
    model: "SKU552458",
  },
  {
    category: "house",
    subcategory: "Other Garden Tools",
    name:
      "Gilet léger JPC tactique Armor pour transporteur de plaques MOLLE avec poches mag",
    price: "29.99",
    raw_price: "74.99",
    currency: "USD",
    discount: "60",
    likes_count: "35",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CB/65/3b9bb7e1-4f57-417d-a5da-97a3178b80f5.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/other-garden-tools-7293/p-1691276.html",
    id: "1691276",
    model: "SKU970648",
  },
  {
    category: "house",
    subcategory: "Other Tools",
    name:
      "Cuisine 360 ° robinet rotatif têtes de robinet d'eau ménage purificateur d'eau filtre pulvérisateur Filtration au charbon actif",
    price: "3.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "160",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6F/87/0d00b2b9-b3fc-431a-ae14-c958cfd4012d.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/other-kitchen-tools-5983/p-1667313.html",
    id: "1667313",
    model: "SKUF04258",
  },
  {
    category: "house",
    subcategory: "Car Mat",
    name: "Filet de camouflage camouflage 4mx2m pour housse de voiture",
    price: "17.55",
    raw_price: "56.67",
    currency: "USD",
    discount: "69",
    likes_count: "130",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#1",
    variation_1_color: "#2",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/banggood/images/03/39/c6a7019e-3181-a6e9-47f5-9503f53d5761.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/banggood/images/03/39/c6a7019e-3181-a6e9-47f5-9503f53d5761.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/banggood/images/03/39/80f2b700-3110-61f3-67b1-f717409a8f05.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/banggood/images/03/39/80f2b700-3110-61f3-67b1-f717409a8f05.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/banggood/images/C2/0A/54144015-520b-46c2-804c-89e6995c2e8a.jpg",
    url: "https://fr.newchic.com/car-mat-7217/p-1090202.html",
    id: "1090202",
    model: "SKU450365",
  },
  {
    category: "house",
    subcategory: "Coussins & Oreillers",
    name: "Coussin en peluche courte souple en forme de dos de chat",
    price: "19.59",
    raw_price: "31.49",
    currency: "USD",
    discount: "38",
    likes_count: "686",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Gray",
    variation_1_color: "White",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/8F/5C/b111a270-ffc9-47b4-b9cc-547c36b974ce.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8F/5C/b111a270-ffc9-47b4-b9cc-547c36b974ce.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/10/5E/3c83fc88-5863-49ca-8f2e-bb140ff5909d.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/10/5E/3c83fc88-5863-49ca-8f2e-bb140ff5909d.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/banggood/images/30/8A/4d7f2b67-9ec7-41a1-b1c5-76113d1d754d.jpg",
    url: "https://fr.newchic.com/cushion-and-pillow-5802/p-1336889.html",
    id: "1336889",
    model: "SKU723736",
  },
  {
    category: "house",
    subcategory: "Other Tools",
    name:
      "Outil de coupe de plis de coupeurs de pli d'acier inoxydable de cuisine",
    price: "3.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "124",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/70/DC/7d6938fd-6aed-4123-b9ca-23404281402f.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/other-kitchen-tools-5983/p-1668100.html",
    id: "1668100",
    model: "SKUF04411",
  },
  {
    category: "house",
    subcategory: "Meat & Poultry Tools",
    name: "Outil de décorticage de pinces à crevettes",
    price: "5.99",
    raw_price: "24.27",
    currency: "USD",
    discount: "75",
    likes_count: "274",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/AC/87/b94dcb10-9492-4e3e-8f2a-3f4cfd220f44.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/meat-and-poultry-tools-7240/p-1571191.html",
    id: "1571191",
    model: "SKUD60801",
  },
  {
    category: "house",
    subcategory: "Hammocks",
    name:
      "Hamac de camping double simple avec moustiquaire extérieure portable",
    price: "26.99",
    raw_price: "67.49",
    currency: "USD",
    discount: "60",
    likes_count: "75",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Grey",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/18/DB/51b25086-d239-4b1d-b1c2-a5d3ef1c6e72.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/18/DB/51b25086-d239-4b1d-b1c2-a5d3ef1c6e72.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/CE/05/767f7e0a-e431-4a1c-b292-7539608d05cf.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CE/05/767f7e0a-e431-4a1c-b292-7539608d05cf.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/73/8B/9037e430-c684-48da-9233-471cb742dcb6.jpg",
    url: "https://fr.newchic.com/hammocks-7289/p-1682580.html",
    id: "1682580",
    model: "SKUF28094",
  },
  {
    category: "house",
    subcategory: "Fruit & Vegetable Tools",
    name:
      "Cuisine créative outils de hachage Gadget poignée taille broyeur d'oignon fleur d'oignon oignon râpé coupe-oignon",
    price: "3.99",
    raw_price: "6.99",
    currency: "USD",
    discount: "43",
    likes_count: "53",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Orange",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/75/60/d877aa90-6ece-47e6-8a3e-a11a559bcfab.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/75/60/d877aa90-6ece-47e6-8a3e-a11a559bcfab.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F8/D0/275b7971-986e-4344-a84b-44ed6105996c.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F8/D0/275b7971-986e-4344-a84b-44ed6105996c.jpg",
    url: "https://fr.newchic.com/fruit-and-vegetable-tools-5978/p-1689345.html",
    id: "1689345",
    model: "SKUE95969",
  },
  {
    category: "house",
    subcategory: "Home Carpets",
    name:
      "Ultra Soft tapis moelleux pour chambre à coucher enfants chambre en peluche tapis de pépinière shaggy tapis de jet de fourrure pour collège dortoir tapis flous salon décoration de la maison tapis",
    price: "18.47",
    raw_price: "29.46",
    currency: "USD",
    discount: "37",
    likes_count: "718",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Fruits verts",
    variation_1_color: "Bleu",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6E/1C/43d550b9-c1af-4acf-9f4e-1f595a001703.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6E/1C/43d550b9-c1af-4acf-9f4e-1f595a001703.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/81/55/fbeb6603-adfb-4c36-82b2-66eefd005a3e.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/81/55/fbeb6603-adfb-4c36-82b2-66eefd005a3e.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/21/05/464efb9d-0fd3-4f2d-8551-fc964c60bd0c.jpeg",
    url: "https://fr.newchic.com/home-carpets-7216/p-1163037.html",
    id: "1163037",
    model: "SKU501867",
  },
  {
    category: "house",
    subcategory: "Food Storage",
    name:
      "1 Pc Verre Sauce Vinaigre Bouteille D'huile Distributeur D'huile Conteneur Sauce Bateaux Condiment Assaisonnement Bouteille Distributeur D'huile D'olive Cuisine",
    price: "5.99",
    raw_price: "10.99",
    currency: "USD",
    discount: "46",
    likes_count: "65",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#01",
    variation_1_color: "#02",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/95/2D/486aceab-4770-4dc7-a401-39631a0bb9e3.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/95/2D/486aceab-4770-4dc7-a401-39631a0bb9e3.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/7E/5F/2f0370e4-2a36-4cb9-8479-a4282ab60cc9.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/7E/5F/2f0370e4-2a36-4cb9-8479-a4282ab60cc9.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C8/CB/5b7283bb-d88c-4c85-a920-0e9f68943dd9.jpg",
    url:
      "https://fr.newchic.com/bottles-and-jars-and-boxes-7256/p-1697653.html",
    id: "1697653",
    model: "SKUE92694",
  },
  {
    category: "house",
    subcategory: "Artisanat",
    name:
      "79 pièces / ensemble moules de moulage de bijoux moules à bijoux en résine de silicone ornement collier pendentif bricolage matériaux de fabrication",
    price: "16.99",
    raw_price: "42.99",
    currency: "USD",
    discount: "61",
    likes_count: "48",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/54/C6/8cf06873-2a5f-4990-9f5c-6212031f7779.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/crafting-5493/p-1684795.html",
    id: "1684795",
    model: "SKUE83703",
  },
  {
    category: "house",
    subcategory: "Broderie à point de croix",
    name:
      "100 pcs Crochet Crochets Ensemble Complet Outil À Tricoter Accessoires Aiguilles À Tricoter Outils De Couture Artisanat Kit avec Étui En Cuir",
    price: "14.99",
    raw_price: "37.49",
    currency: "USD",
    discount: "60",
    likes_count: "70",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/4F/78/35048314-e2d4-4070-8fcf-15bdc57f7b99.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url:
      "https://fr.newchic.com/cross-stitch-and-embroidery-5897/p-1694967.html",
    id: "1694967",
    model: "SKUF32425",
  },
  {
    category: "house",
    subcategory: "Boîte de stockage",
    name:
      "Salle de bains toilette mural rouleau papier conteneur étagère multifonctionnelle téléphone portable verre montre titulaire boîte à mouchoirs",
    price: "22.99",
    raw_price: "24",
    currency: "USD",
    discount: "0",
    likes_count: "26",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/87/59/5af8e67e-1d04-4d95-b361-a8714e4fa826.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/87/59/5af8e67e-1d04-4d95-b361-a8714e4fa826.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/68/BD/34fc5e5d-6ff0-43a0-9d04-84133de7cf03.jpg",
    url: "https://fr.newchic.com/storage-boxes-4913/p-1687403.html",
    id: "1687403",
    model: "SKUE53219",
  },
  {
    category: "house",
    subcategory: "Artisanat",
    name:
      "187 pcs / ensemble Kit de broderie Aiguille de poinçon Motifs de broderie Kit d'aiguille de poinçon Outil d'artisanat Broderie Stylo Ensemble Fils pour la couture Tricot DIY Enfileurs",
    price: "23.99",
    raw_price: "59.99",
    currency: "USD",
    discount: "60",
    likes_count: "86",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9D/76/47f2394a-87ef-47a0-a3f6-8a11650e2bd9.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/crafting-5493/p-1693365.html",
    id: "1693365",
    model: "SKUF32293",
  },
  {
    category: "house",
    subcategory: "Sacs pour plantes & Aquaculture",
    name: "Pot de fleur suspendu vert pour balcon intérieur et extérieur",
    price: "20.71",
    raw_price: "35.84",
    currency: "USD",
    discount: "42",
    likes_count: "110",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "Green",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/39/54/66b549b6-a4bf-4b68-87dd-2b7d23783301.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/39/54/66b549b6-a4bf-4b68-87dd-2b7d23783301.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/4E/3F/6d809ccf-3620-4200-a3f8-12261f1dd23d.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/4E/3F/6d809ccf-3620-4200-a3f8-12261f1dd23d.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B3/49/7a57ad69-e254-4f96-8839-4dac01c2e6a9.jpg",
    url: "https://fr.newchic.com/plant-bag-and-aquaculture-5042/p-1660559.html",
    id: "1660559",
    model: "SKUE48915",
  },
  {
    category: "house",
    subcategory: "Lits & Tapis",
    name: "Housse de canapé anti-adhérente pour animaux de compagnie",
    price: "28.99",
    raw_price: "56.99",
    currency: "USD",
    discount: "49",
    likes_count: "80",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Coffee",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/1D/15/a1a1eb8b-d9d6-46a1-b398-ec3ed886ff42.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/1D/15/a1a1eb8b-d9d6-46a1-b398-ec3ed886ff42.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/25/3A/90f90e3f-ffb3-41f6-9322-777204fb205e.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/25/3A/90f90e3f-ffb3-41f6-9322-777204fb205e.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/24/BE/1b39dbf5-b506-4407-b5f4-f630ed673fb3.jpeg",
    url: "https://fr.newchic.com/cats-beds-and-mats-5610/p-1653974.html",
    id: "1653974",
    model: "SKUE71304",
  },
  {
    category: "house",
    subcategory: "Artisanat",
    name:
      "248 Pcs Boucle D'oreille Époxy Résine Moules Kit Bohême Drop Dangle Résine Boucle D'oreille Moule Bijoux De Mode Résine Silicone Moules Art Artisanat",
    price: "14.99",
    raw_price: "37.99",
    currency: "USD",
    discount: "61",
    likes_count: "58",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/58/72/b46e7cc8-861d-4775-b66c-7d7def038e57.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/crafting-5493/p-1685359.html",
    id: "1685359",
    model: "SKUE83581",
  },
  {
    category: "house",
    subcategory: "Other Garden Tools",
    name:
      "Bricolage jardin pavage moule manuel pavage ciment brique pierre route moule",
    price: "26.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "30",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/88/4A/3915bb61-df5f-4427-89e4-6435ee147233.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/other-garden-tools-7293/p-1684369.html",
    id: "1684369",
    model: "SKUF26575",
  },
  {
    category: "house",
    subcategory: "Literie",
    name:
      "Ensemble de draps de lit de confort d'hôtel de luxe Ensemble de literie Poches profondes Résistant aux rides et à la décoloration Ensemble de draps et d'oreillers hypoallergéniques",
    price: "12.5",
    raw_price: "62.99",
    currency: "USD",
    discount: "80",
    likes_count: "48",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Lake Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/FE/9A/febbc5a0-bba0-4ed8-bb82-cdaee49a9f2a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FE/9A/febbc5a0-bba0-4ed8-bb82-cdaee49a9f2a.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C5/6F/71f899b8-685c-4e37-8060-ebced53f52e9.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C5/6F/71f899b8-685c-4e37-8060-ebced53f52e9.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8C/85/37d255a9-ea21-4c51-8b8d-1f26af1b89d7.jpg",
    url: "https://fr.newchic.com/bedding-sets-5811/p-1689355.html",
    id: "1689355",
    model: "SKUF27684",
  },
  {
    category: "house",
    subcategory: "Home Carpets",
    name:
      "Tapis rond 3D, tapis antidérapant à carreaux Vortexs Optical Illusions, tapis de sol antidérapant Durbale paillasson noir blanc non tissé, pour salon cuisine de chambre à coucher",
    price: "14.99",
    raw_price: "47.49",
    currency: "USD",
    discount: "68",
    likes_count: "35",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/15/1D/456e340e-2c77-49ea-9af0-3f4dae77ab74.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/home-carpets-7216/p-1701338.html",
    id: "1701338",
    model: "SKUF55255",
  },
  {
    category: "house",
    subcategory: "Other Tools",
    name:
      "Matériel de silicone de catégorie comestible de sac de pâte de pétrissage de main antiadhésif de ménage multifonctionnel",
    price: "5.99",
    raw_price: "8.99",
    currency: "USD",
    discount: "33",
    likes_count: "72",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/58/52/f19d0078-8332-479c-80b9-9329851e8c30.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/other-kitchen-tools-5983/p-1684862.html",
    id: "1684862",
    model: "SKUE92949",
  },
  {
    category: "house",
    subcategory: "Oreillers",
    name: "Oreiller en latex naturel standard",
    price: "22.55",
    raw_price: "74.81",
    currency: "USD",
    discount: "70",
    likes_count: "91",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/81/FA/b2c90d4b-400b-4fbb-80e9-fa74a05520a3.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/pillows-and-eyeshade-5809/p-1370339.html",
    id: "1370339",
    model: "SKUA49939",
  },
  {
    category: "house",
    subcategory: "Grasses",
    name:
      "Egrow 12 Pcs / Pack Rhodochiton Atrosanguineus Graines Cloche Fleur de Vigne pour Maison Jardin plante",
    price: "4.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "58",
    is_new: "false",
    brand: "Egrow",
    brand_url: "https://fr.newchic.com/egrow-brand-819.html",
    codCountry: "PH,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BD/51/a9a0eea9-f07a-458b-ad94-a26484d58e26.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/egrow-grasses-8677/p-1659078.html",
    id: "1659078",
    model: "SKUE67040",
  },
  {
    category: "house",
    subcategory: "Openers",
    name: "Ouvre-boîtes",
    price: "12.99",
    raw_price: "24.99",
    currency: "USD",
    discount: "48",
    likes_count: "13",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FE/E4/8080840b-48b6-47e6-9688-61d5a5f999d8.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "/",
    image_url: "",
    url: "https://fr.newchic.com/openers-5980/p-1716362.html",
    id: "1716362",
    model: "SKUF81490",
  },
  {
    category: "house",
    subcategory: "Other Garden Tools",
    name:
      "Jardinière Perceuse Planteur Tige Spirale Jardin Plantation Fleur Bit",
    price: "9.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "53",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/97/3C/19bb6aff-deb8-4b89-8dac-42c5ec96a378.jpg",

    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/other-garden-tools-7293/p-1690468.html",
    id: "1690468",
    model: "SKUF32113",
  },
  {
    category: "house",
    subcategory: "Food Storage",
    name:
      "Cuisine 24 Grille Boîte Réfrigérateur Bac À Légumes Boîte De Rangement Portable Pique-Nique Boîte En Plastique Plateau",
    price: "9.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "80",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/94/6F/b492bf46-79e8-4707-be00-2802311f912f.jpg",

    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url:
      "https://fr.newchic.com/bottles-and-jars-and-boxes-7256/p-1695710.html",
    id: "1695710",
    model: "SKUE99272",
  },
  {
    category: "house",
    subcategory: "Grasses",
    name:
      "Egrow 5 Pcs / Pack Obcordata Graines Papillon Vert Bonsaï pour Jardin Maison Plante",
    price: "4.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "44",
    is_new: "false",
    brand: "Egrow",
    brand_url: "https://fr.newchic.com/egrow-brand-819.html",
    codCountry: "PH,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8E/0E/846facef-01ed-4ced-aded-eaf2f5f33bb0.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url: "/",
    url: "https://fr.newchic.com/egrow-grasses-8677/p-1658837.html",
    id: "1658837",
    model: "SKUE68238",
  },
];

export default House;
